
import { Suspense } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import ContactHero from './components/ContactHero';
import ContactInfo from './components/ContactInfo';
import SocialLinks from './components/SocialLinks';

export default function ContactPage() {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <div className="min-h-screen bg-white">
        <Header />
        <main>
          <ContactHero />
          <div className="py-20 bg-gray-50">
            <div className="max-w-7xl mx-auto px-6">
              <div className="grid grid-cols-1 gap-12">
                <ContactInfo />
                <SocialLinks />
              </div>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </Suspense>
  );
}
